const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPwcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 758.995,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1000 325.903H636.265v-93.1H1000v93.1z",
    style: {
      fill: "#e669a2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.756 325.903H636.265V93.05h316.49v232.852z",
    style: {
      fill: "#f3be26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.998 325.903H636.265V0h185.733v325.903z",
    style: {
      fill: "#ee9c34",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.539 325.903H636.265V36.366h222.274v289.537z",
    style: {
      fill: "#f3bc87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 36.42v289.453h185.765V36.421H636.213z",
    style: {
      fill: "#e3721c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.016 325.903h186.249v46.555H450.016v-46.555z",
    style: {
      fill: "#ad1b02",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 93v232.873h222.432V93H636.213z",
    style: {
      fill: "#e88d14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 93v232.873h185.765V93H636.213z",
    style: {
      fill: "#d85604",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.414 325.903h-116.15V186.14h116.15v139.762z",
    style: {
      fill: "#c14303",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 232.87v93.003h316.65V232.87h-316.65z",
    style: {
      fill: "#db4e18",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 232.87v93.003h222.432V232.87H636.213z",
    style: {
      fill: "#d1390d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 232.87v93.003h185.765V232.87H636.213z",
    style: {
      fill: "#c22303",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.213 232.87v93.003h116.315V232.87H636.213z",
    style: {
      fill: "#ad1b02",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      color: "#000",
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M805.26 177.456c-31.69 5.634-48.592 29.578-48.592 71.127 0 42.254 22.535 70.423 55.634 70.423 16.197 0 30.281-5.634 59.859-20.423v34.507c-35.916 16.902-57.042 21.127-85.211 21.127-31.69 0-54.226-7.747-71.831-26.76-18.31-18.31-28.17-42.254-28.17-69.719 0-59.86 45.071-101.408 110.564-101.408 42.958 0 73.24 20.422 73.24 49.295 0 19.014-14.085 32.395-34.508 32.395-10.563 0-19.014-3.521-30.986-9.86M646.809 257.738c28.873-35.915 39.436-50.704 39.436-68.31 0-17.605-14.084-33.098-33.802-33.098-11.268 0-21.831 6.338-26.761 11.971v73.944l-47.183 63.38V161.963h-45.07l-74.648 123.24v-123.24h-25.353l-68.31 15.493v17.606l37.325 3.521V351.4h47.183l71.83-118.31V351.4h52.818M222.16 327.456h10.564c38.028 0 59.155-23.24 59.155-69.718 0-38.732-16.901-59.86-48.591-59.86-4.226 0-10.564.705-21.127 2.818v126.76zm0 83.099 30.987 7.042v17.606H131.316v-17.606l28.169-7.042V197.879h-30.986v-17.606l73.944-22.535h19.718v25.352c34.507-21.127 46.479-24.648 64.789-24.648 40.845 0 71.83 38.028 71.83 90.845 0 60.564-41.549 102.113-104.929 102.113-7.042 0-19.014-.704-31.69-1.408",
    transform: "translate(-128.499 323.792)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwcLogo);
export default __webpack_public_path__ + "static/media/pwc-logo.7e08c6114719d12d88d039bca5318da4.svg";
export { ForwardRef as ReactComponent };